'use client'

import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { convertPhoneNumberToVietnam } from '@/lib/utils'
import { getPageType } from '@/middleware/page-type'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

// Khai báo types
interface InsiderUser {
  email: string
  name: string
  gdpr_optin: boolean
  email_optin: boolean
  phone_number: string
}

interface InsiderPage {
  type: string
}

interface InsiderListing {
  items: unknown[]
}

// Interface cho insider_object với cả static và dynamic keys
interface InsiderObject {
  page?: InsiderPage
  user?: InsiderUser
  listing?: InsiderListing
  basket?: unknown
  transaction?: unknown
  product?: unknown
  [key: string]: unknown // Cho phép thêm key động khác nếu cần
}

interface InsiderAPI {
  track: (event: string) => void
  eventManager?: {
    dispatch?: (event: string) => void
  }
}

declare global {
  interface Window {
    Insider?: InsiderAPI
    insider_object: InsiderObject
  }
}

// Component
export const InsiderTracker = () => {
  const { data: user } = useUserQuery()
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window === 'undefined') return

    // Đảm bảo insider_object tồn tại
    window.insider_object = window.insider_object || {}

    // Cập nhật page type dựa trên pathname mới
    const pageType = getPageType(pathname)
    window.insider_object.page = { type: pageType }

    // Cập nhật thông tin người dùng nếu có
    if (user) {
      window.insider_object.user = {
        email: user.email,
        name: user.fullname,
        gdpr_optin: true,
        email_optin: true,
        phone_number: convertPhoneNumberToVietnam(user.phone),
      }
    }

    // Nếu script Insider đã load, track page view
    // Điều này quan trọng cho client-side navigation
    if (window.Insider?.track) {
      window.Insider.track('page')
    }
    // Nếu nội dung thay đổi mà URL KHÔNG đổi
    // Ví dụ: phân trang danh mục, checkout step
    // delay lhoảng 1s
    setTimeout(() => {
      window?.Insider?.eventManager?.dispatch?.('init-manager:re-initialize')
    }, 1000)
  }, [pathname, user])

  // useEffect(() => {
  //   delayLoad(() => {
  //     if (document.getElementById('insider-script')) return

  //     const script = document.createElement('script')
  //     script.id = 'insider-script'
  //     script.src = 'https://coolmatevn.api.useinsider.com/ins.js?id=10003475'
  //     script.async = true
  //     document.head.appendChild(script)
  //   }, 3000)
  // }, [])

  return null
}
